<h2 mat-dialog-title>Warning!</h2>
<mat-dialog-content fxLayout="row">
  <p>{{passedData}}</p>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
  <button mat-button color="warn" [mat-dialog-close]="true">YES</button>
  <button mat-button [mat-dialog-close]="false">NO</button>
</mat-dialog-actions>